import * as types from './mutation-types'
import {SET_CURRENT_SHOP} from "./mutation-types";

export default {
    [types.SET_SHOPS](state, data) {
        state.shops = data
    },

    [types.SET_SHOP](state, data) {
        state.shop = data
    },

    [types.ADD_SHOP](state, data) {
        state.shops.unshift(data)
    },

    [types.UPDATE_SHOP](state, data) {
        const index = state.shops.findIndex(shop => shop.id === data.id)
        if (index !== -1) {
            state.shops.splice(index, 1, data)
        }
        if (state.shop && state.shop.id === data.id) {
            state.shop = data
        }
    },

    [types.DELETE_SHOP](state, id) {
        state.shops = state.shops.filter(shop => shop.id !== id)
    },

    [types.SET_LOADING](state, loading) {
        state.loading = loading
    },

    [types.SET_PAGINATION](state, pagination) {
        state.pagination = pagination
    },

    [types.SET_AVAILABLE_STORES](state, stores) {
        state.availableStores = stores
    },

    [types.SET_CURRENT_SHOP](state, id) {
        state.currentShopId = id
    },
}
